<template>
  <div class="translator main">
    <MainBackButton :forceHome="true" />
    <p class="header has-text-left">
      <span class="title is-5 has-text-primary" style="padding-left: 45px"
        >Translator</span
      >
      <!-- <span class="is-pulled-right tag is-primary">{{ hostURL() }}</span> -->
      <button
        v-show="translations && selected"
        class="delete is-medium is-pulled-right"
        @click="selected = null"
      />
    </p>

    <div v-if="translations && selected" style="padding: 6px">
      <p style="font-size: 1.2em; font-weight: 500; opacity: 0.8">
        {{ selected }}
        <span class="is-pulled-right">
          <span
            v-for="l in languages"
            :key="l"
            class="
              button
              is-small is-rounded is-info
              has-text-weight-medium
              is-uppercase
            "
            :class="{ 'is-outlined': lang !== l }"
            style="padding: 0 4px; margin: 0 3px"
            @click="lang = l"
            >{{ l }}</span
          >&nbsp;
          <!-- <button class="delete is-medium" @click="selected = null" /> -->
        </span>
      </p>
      <div class="table-wrapper no-scrollbar">
        <table class="table is-fullwidth is-hoverable">
          <thead style="background-color: #efe">
            <tr>
              <th>English</th>
              <th>{{ $t(`language.${lang}`) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="t in base" :key="t.text">
              <td class="is-narrow" style="max-width: calc(50vw - 12px)">
                <p class="clamp" @click="infoToast(t.text, 'top')">
                  {{ t.text }}
                  <span
                    v-show="t.count > 1"
                    class="tag is-rounded has-text-info"
                    >{{ t.count }}</span
                  >
                </p>
              </td>
              <td>
                <span v-if="translation(t.text)">sajkljkl</span>
                <span
                  v-else
                  class="button is-rounded is-small is-grey has-text-link"
                  @click="setTranslation(t.text)"
                  >Set Translation</span
                >
              </td>
            </tr>
            <tr style="background-color: lightyellow">
              <td colspan="2" class="has-text-centered has-text-success">
                END
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="list-btns" style="padding: 10px">
      <a v-for="t in things" :key="t" class="button" @click="select(t)">{{
        t
      }}</a>
    </div>
  </div>
</template>


<script>
import MainBackButton from "@/components/MainBackButton";

export default {
  name: "Translator",
  components: { MainBackButton },
  data() {
    return {
      selected: null,
      loading: true,
      things: ["Business Categories", "Lists"],
      businessCategories: null, // Thai, Chinese, Mexican etc
      lists: null, // Eat lists etc
      translations: null,
      languages: ["th", "zh", "ja"],
      lang: "th",
    };
  },
  computed: {
    base() {
      if (!this.translations) return [];
      return this.translations.base;
    },
  },
  mounted() {
    console.log("Translator mounted");
    this.getBusinessCategories();
    this.getLists();
  },
  methods: {
    select(t) {
      this.selected = t;
      this.getTranslations(t);
    },
    // parent_id = business_categories, lists
    // parent_type = translation
    // blob_type = en, th, zh, ja
    getTranslations(t) {
      var loader = this.loadingDots("orange");
      this.translations = null; // reset
      this.$store
        .dispatch("getTranslationsByParent", t)
        .then((res) => (this.translations = res.data))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    getBusinessCategories() {
      this.$store
        .dispatch("getTranslationsByParent", "Business Categories")
        .then((res) => (this.businessCategories = res.data))
        .catch((err) => this.apiError(err));
    },
    getLists() {
      this.$store
        .dispatch("getTranslationsByParent", "Lists")
        .then((res) => (this.lists = res.data))
        .catch((err) => this.apiError(err));
    },
    translation() {
      return false;
    },
    setTranslation(text) {
      var language = this.$t(`language.${this.lang}`);
      this.$swal({
        title: text,
        html: `Translation in ${language}:`,
        input: "text",
        inputValue: "existing",
        showCloseButton: true,
      });
    },
  },
};
</script>

<style scoped>
.main {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  text-align: left;
  padding: 10px;
}
.header {
  padding: 8px 0;
  margin-right: 10px;
}
.list-btns .button {
  display: block;
  margin-bottom: 10px;
}
.table-wrapper {
  max-height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
  margin-top: 10px;
}
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 4px;
}
</style>